import React from 'react';
import Button from '../../Button';
import TextView from '../../TextView';

function index({ name, image, leftButtonText, rightButtonText, onLeftClick, onRightClick }) {
  return (
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <div style={{ display: 'flex', alignItems: 'center' , gap: '12px' }}>
          <img src={image} alt={name} style={{width:'40px',height:'40px'}} />
              <TextView variant="notifName">
                {name}
              </TextView>
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>
            <Button 
             onClick={onLeftClick} 
             style={{padding:'13px'}}>
              {leftButtonText}
            </Button>
            <Button
            variant='outlined'
              onClick={onRightClick}
              style={{padding:'13px'}}
            >
                {rightButtonText}
            </Button>
          </div>
        </div>
  );
};

export default index;
